export const status = [
    { name: 'SELECT STATUS', value: null },
    { name: 'REVIEW', value: 'review' },
    { name: 'RE-SUBMIT', value: 're-submit' },
    { name: 'REQUEST FOR SHIPPER INFORMATION', value: 'request si' },
    { name: 'COMPLETED', value: 'completed' },
]